import { PINInput as SharedPINInput } from "@sportal/cdk";
import "./PINInput.scss";

export const PINInput = SharedPINInput;
